import React, { Component } from 'react';
import ReactSVG from 'react-svg';
import logo from './tugbot-logo.svg';
import './tugbot-logo.css';

class TugbotLogo extends Component {

  /*constructor (props) {
    super(props);
  }*/
  
  render() {
    return (
      <div className="tugbot-logo">
        <ReactSVG
          path={ logo }
          callback={svg => console.log(svg)}
          evalScript="always"
          />
        <h1>TUGBOT</h1>
      </div>
    )
  }

}

export default TugbotLogo;


// WEBPACK FOOTER //
// ./src/components/TugbotLogo/TugbotLogo.component.js